/* Dropdayz — aanvullingen op de site.

   25 AUGUSTUS 2026 — ALLE MENU-INGREPEN ZIJN HIER WEGGEHAALD. Ze staan nu in
   sections/header.liquid, waar ze horen:
     * Skincare in het Accessoires-mega-paneel;
     * Jacquemus-tassen uit datzelfde paneel;
     * Skincare in het categorieblok van de mobiele la (dat blok is inmiddels
       helemaal weg);
     * de linkrijen onderaan de mobiele la (Luxury Vintage, Sneaker request,
       en nieuw: Accessoires en Skincare).

   Ze stonden hier ooit omdat header.liquid 38 kB is en niet in één keer via
   de API te herschrijven zou zijn. Dat bleek niet te kloppen. Een template
   repareren of aanvullen door achteraf HTML in te voegen is onzichtbaar voor
   wie later in de bron kijkt, en zoekmachines zien die links niet.

   WAT HIER NOG STAAT — en waarom het hier wél thuishoort: dit zijn
   gedragingen, geen markup. Ze hebben één gedelegeerde listener per pagina
   nodig en horen bij geen enkel specifiek sjabloon.
     1. QUICK ADD vanaf de maatpillen op de collectiekaarten.
     2. Contactlinks naar het e-mailadres.

   Wordt één keer per pagina geladen vanuit snippets/ddz-footer-info.liquid,
   met defer. */
(function () {
  var MAIL = 'info@dropdayz.be';

  /* ---- 1. QUICK ADD: klik op een maatpil van een productkaart ----
     De pil vult alleen het variant-id in en dient het formuliertje in rond
     de maatstrook (snippets/ddz-card-sizes.liquid). Het toevoegen zelf doet
     de cart drawer via zijn capture-phase submit handler — één
     add-to-cart-pad voor de hele site. Het verborgen veld is nodig omdat die
     handler FormData zonder submitter bouwt. */
  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest ? e.target.closest('[data-ddz-qa-size]') : null;
    if (!pill) { return; }
    var form = pill.closest('[data-ddz-quickadd]');
    var hidden = form && form.querySelector('[data-ddz-qa-id]');
    if (!form || !hidden) { return; }

    e.preventDefault();
    e.stopPropagation();

    hidden.value = pill.getAttribute('data-ddz-qa-size') || '';
    if (!hidden.value) { return; }

    pill.classList.add('is-busy');
    window.setTimeout(function () { pill.classList.remove('is-busy'); }, 1400);

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  /* ---- 2. contactlinks -> e-mail ---- */
  try {
    Array.prototype.slice.call(document.querySelectorAll('a[href*="/pages/contact"]')).forEach(function (a) {
      a.setAttribute('href', 'mailto:' + MAIL);
      var txt = (a.textContent || '').trim().toLowerCase();
      if (txt === 'contactpagina' || txt === 'neem contact op') { a.textContent = 'Mail ons'; }
    });
  } catch (e) {}
})();
